import { createStore } from "redux";

const userReducer = (
  state = {
    accountDetails: null,
    isSuperuser: undefined,
    errorFound: false,
    editChecklistId: null,
    errorMessage: "",
    status_filter: "",
    fiscal_year_filter: "",
    period_filter: "",
    parent_company_filter: "",
    subsidiary_filter: "",
    region_filter: "",
    company_filter: "",
    supervised_entity_filter: "",
    qualitative_evaluation_only_filter: "",
    control_function_filter: "",
    visible_on_bi_filter: ""
  },
  action
) => {
  let loggedIn = (JSON.parse(sessionStorage.getItem("loggedIn")));
  if (action.type === 'setAccountDetails') {
    return {
      ...state,
      accountDetails: action.userData,
    };
  }
  if (action.type === 'makeSuperuser') {
    let isSuperUser = false;
    for (const el of action.userData.authorities) {
      if (el.type === "SU") {
        isSuperUser = true;
        break;
      }
    }
    if (loggedIn && isSuperUser) {
      return {
        ...state,
        isSuperuser: true
      }
    } else {
      return {
        ...state,
        isSuperuser: false
      }
    }
  }

  if (action.type === 'setEditChecklistId') {
    return {
      ...state,
      editChecklistId: action.checklistId
    }
  }

  // Checklist Monitor filter states
  if (action.type === 'status_filter') {
    return {
      ...state,
      status_filter: action.filterValue
    }
  }

  if (action.type === 'fiscal_year_filter') {
    return {
      ...state,
      fiscal_year_filter: action.filterValue
    }
  }

  if (action.type === 'period_filter') {
    return {
      ...state,
      period_filter: action.filterValue
    }
  }

  if (action.type === 'parent_company_filter') {
    return {
      ...state,
      parent_company_filter: action.filterValue
    }
  }
  
  if (action.type === 'subsidiary_filter') {
    return {
      ...state,
      subsidiary_filter: action.filterValue
    }
  }

  if (action.type === 'region_filter') {
    return {
      ...state,
      region_filter: action.filterValue
    }
  }

  if (action.type === 'company_filter') {
    return {
      ...state,
      company_filter: action.filterValue
    }
  }

  if (action.type === 'supervised_entity_filter') {
    return {
      ...state,
      supervised_entity_filter: action.filterValue
    }
  }

  if (action.type === 'qualitative_evaluation_only_filter') {
    return {
      ...state,
      qualitative_evaluation_only_filter: action.filterValue
    }
  }

  if (action.type === 'control_function_filter') {
    return {
      ...state,
      control_function_filter: action.filterValue
    }
  }

  if (action.type === 'visible_on_bi_filter') {
    return {
      ...state,
      visible_on_bi_filter: action.filterValue
    }
  }

  if (action.type === 'resetChecklistMonitorFilters') {
    console.log("reset checklist monitor filters")
    return {
      ...state,
      status_filter: "",
      fiscal_year_filter: "",
      period_filter: "",
      parent_company_filter: "",
      subsidiary_filter: "",
      region_filter: "",
      company_filter: "",
      supervised_entity_filter: "",
      qualitative_evaluation_only_filter: "",
      control_function_filter: "",
      visible_on_bi_filter: ""
    }
  }

  // Checklist Monitor filter states End

  // if (action.type === 'handleError') {
  //   return {
  //     ...state,
  //     errorFound: action.errFound,
  //     errorMessage: action.errMessage ? action.errMessage : ""
  //   }
  // }
  return state;
};

const store = createStore(userReducer);

export default store;
